import React, { useEffect, useRef } from "react";
import { userManager } from "../oidc";

/**
 * Verarbeitet den Silent-Renew-Callback von Auth0 in einem versteckten iFrame.
 * Ohne diese Route läuft `automaticSilentRenew` (oidc.ts) ins Leere, da
 * `signinSilentCallback()` nie aufgerufen wird.
 */
const SilentCallbackPage: React.FC = () => {
  const callbackProcessed = useRef(false);

  useEffect(() => {
    if (callbackProcessed.current) return;
    callbackProcessed.current = true;

    userManager.signinSilentCallback().catch(() => {});
  }, []);

  return null;
};

export default SilentCallbackPage;
